import React from "react";
import styled from "styled-components";

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 0.9rem;
  color: #444;
  font-weight: 500;
`;

const StyledSelect = styled.select`
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.95rem;
  color: #222;
  background: #fff;
  outline: none;

  &:focus {
    border-color: #ff0102;
  }
`;

export default function InputSelect({ label, value, options = [], onChange }) {
  return (
    <SelectWrapper>
      {label && <Label>{label}</Label>}
      <StyledSelect
        value={value?.value || ""}
        onChange={(e) => {
          const opt = options.find((o) => o.value === e.target.value);
          onChange?.(opt || { value: e.target.value, label: e.target.value });
        }}
      >
        <option value="">Selecciona...</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </StyledSelect>
    </SelectWrapper>
  );
}